// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navigation-item-link[data-v-f146a706],.navigation-item-link[data-v-f146a706]:active,.navigation-item-link[data-v-f146a706]:hover,.navigation-item-link[data-v-f146a706]:visited{text-decoration:none;font-family:OpenSans;font-size:1.4rem;font-weight:400;font-style:normal;font-stretch:normal;line-height:1.4;letter-spacing:.7px;text-align:left}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
